import styled from 'styled-components';
import { Cell } from './Cell';

export const ActionCell = styled(Cell)`
  display: flex;
  justify-content: flex-end;
  background-color: transparent;
  width: 100%;
`;
